import { render, staticRenderFns } from "./newsListing.vue?vue&type=template&id=c7dc94fe&"
import script from "./newsListing.vue?vue&type=script&lang=js&"
export * from "./newsListing.vue?vue&type=script&lang=js&"
import style0 from "./newsListing.vue?vue&type=style&index=0&id=c7dc94fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports